import React from 'react';
import { Link } from 'react-router-dom';

function About() {
  return (
    <>
      <div class="page-banner-area">
        <div class="container">
          <div class="page-banner-content">
            <h2>About us</h2>
            <ul>
              <li>
                <Link to={"/"}>Home</Link>
              </li>
              <li>About us</li>
            </ul>
          </div>
        </div>
      </div>
      <section class="about-area bg-ffffff ptb-100">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="about-content-warp">
                <span>About</span>
                <h3>We operate our services in many countries around the world.</h3>
                <p>Go cashless with Pargati app. You can pay mobile, gas, electricity, DTH, broadband bills and recharges. Pargati is a revolutionary app to make mobile payments in Nepal in a secure and simple way.</p>

                <ul class="about-warp-list">
                  <li>
                    <i class="flaticon-check"></i>
                    Remitance Service
                  </li>
                  <li>
                    <i class="flaticon-check"></i>
                    Recharge Service
                  </li>
                  <li>
                    <i class="flaticon-check"></i>
                    Bus / Air Booking Services
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="about-image">
                <a href="https://www.youtube.com/watch?v=-67xX2__1oM" class="video-btn popup-youtube">
                  <i class='bx bx-play'></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
